// const config = {
//   URL_PATH: "http://localhost:8080",
// };

const config = {
  URL_PATH: "https://funder-backend.onrender.com",
};

export default config;
